// @ts-nocheck
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  OnInit,
  OnDestroy,
  SecurityContext,
  ChangeDetectionStrategy,
} from '@angular/core';
import { LoggerService } from '@way/theme-host/services/logger.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { WebsiteElementData } from '@way/theme-host/shared/components/website-element';
import {
  ChampsPageHeaderComponent,
  NavigationItem,
  Logo,
  CTAButton,
} from '../shared/page-header/page-header.component';
import { ChampsPageFooterComponent } from '../shared/footer/footer.component';
import { HeroLayout1PreviewComponent } from '../../panels/hero-panel/layouts/layout_1';
import { HeroLayout2PreviewComponent } from '../../panels/hero-panel/layouts/layout_2';
import { HeroLayout3PreviewComponent } from '../../panels/hero-panel/layouts/layout_3';
import { HeroLayout4PreviewComponent } from '../../panels/hero-panel/layouts/layout_4';
import { HeroLayout5PreviewComponent } from '../../panels/hero-panel/layouts/layout_5';
import { HeroLayout6PreviewComponent } from '../../panels/hero-panel/layouts/layout_6';
import { HeroLayout7PreviewComponent } from '../../panels/hero-panel/layouts/layout_7';
import {
  InfoLayout1PreviewComponent,
  InfoLayout1Data,
} from '../../panels/info-panel/layouts/layout_1';
import {
  InfoLayout2PreviewComponent,
  InfoLayout2Data,
} from '../../panels/info-panel/layouts/layout_2';
import {
  InfoLayout3PreviewComponent,
  InfoLayout3Data,
} from '../../panels/info-panel/layouts/layout_3';
import {
  InfoLayout4PreviewComponent,
  InfoLayout4Data,
} from '../../panels/info-panel/layouts/layout_4';
import {
  InfoLayout5PreviewComponent,
  InfoLayout5Data,
} from '../../panels/info-panel/layouts/layout_5';
import {
  BookingLayout1PreviewComponent,
  BookingLayout1Data,
} from '../../panels/booking-panel/layouts/layout_1';
import {
  BookingLayout2PreviewComponent,
  BookingLayout2Data,
} from '../../panels/booking-panel/layouts/layout_2';
import {
  ContactLayout1PreviewComponent,
  ContactLayout1Data,
} from '../../panels/contact-panel/layouts/layout_1';
import {
  ContactLayout2PreviewComponent,
  ContactLayout2Data,
} from '../../panels/contact-panel/layouts/layout_2';
import { resolveFooterQuickLinks } from '@way/theme-host/shared/utils/footer-quick-links.util';

export interface WebsiteElement extends Omit<WebsiteElementData, 'selected'> {
  type:
    | 'header'
    | 'hero'
    | 'section'
    | 'testimonials'
    | 'services'
    | 'booking'
    | 'contact'
    | 'footer'
    | 'packages'
    | 'coupons'
    | 'fleets'
    | 'express-details';
  selected?: boolean; // Make selected optional for compatibility
  content: {
    title?: string;
    titleStyle?:
      | string
      | {
          fontWeight?: 'bold' | null;
          fontStyle?: 'italic' | null;
          textDecoration?: 'underline' | null;
          textAlign?: 'left' | 'center' | 'right' | 'justify' | null;
        };
    backgroundColor?: string; // Background color from layout.background_color
    cardColor?: string; // Card color from layout.card_color (for testimonials)
    subtitle?: string;
    description?: string;
    buttonText?: string;
    buttonLink?: string; // Button navigation link
    button?: {
      text?: string;
      backgroundColor?: string;
      textColor?: string;
    };
    imageUrl?: string; // Legacy support
    image?: {
      src?: string;
      alt?: string;
      width?: string;
      height?: string;
      scaletype?: 'fill' | 'fit' | 'stretch';
    };
    backgroundImage?: string; // For full background images (e.g., hero section)
    layout?:
      | 'layout_1'
      | 'layout_2'
      | 'layout_3'
      | 'layout_4'
      | 'layout_5'
      | 'layout_6'
      | 'layout_7'
      | '1'
      | '2'
      | '3'
      | '4'
      | '5'
      | '6'
      | '7'
      | {
          type:
            | 'layout_1'
            | 'layout_2'
            | 'layout_3'
            | 'layout_4'
            | 'layout_5'
            | 'layout_6'
            | 'layout_7';
          grid_columns?: number;
          image_alignment?: string;
          padding?: string;
          background_color?: string;
        }; // Hero layout type - supports both old format (string) and new API format (object with type)
    testimonials?: {
      id: string;
      text: string;
      author: {
        name?: string;
        title?: string;
        avatar?: string;
      };
      rating?: number;
      date?: string;
    }[];
    services?: {
      id?: string;
      name?: string;
      title?: string;
      description?: string;
      price?: string;
      duration?: string;
      image?: string;
      icon?: string;
    }[];
    formFields?: {
      id: string;
      name: string;
      label: string;
      type: string;
      placeholder?: string;
      required: boolean;
      validation?: any;
      options?: {
        value: string;
        label: string;
        disabled?: boolean;
      }[];
    }[];
    availableServices?: {
      id: string;
      name: string;
      description: string;
      price: string;
      duration: string;
      available: boolean;
    }[];
    map?: {
      image: string;
      alt: string;
      coordinates?: {
        lat: number;
        lng: number;
      };
      pin?: {
        image: string;
        alt: string;
      };
    };
    address?: string;
    phone?: string;
    email?: string;
    mapEmbedUrl?: string;
    contactInfo?: {
      address?: {
        street: string;
        city: string;
        state: string;
        zipCode: string;
        country?: string;
      };
      phone?: string;
      email?: string;
      website?: string;
    };
    socialLinks?: {
      platform: string;
      url?: string;
      link?: string;
      icon?: string;
      label?: string;
    }[];
    businessHours?: {
      day: string;
      openTime: string;
      closeTime: string;
      closed: boolean;
    }[];
    logo?: {
      image: string;
      alt: string;
      link: string;
    };
    navigation?: {
      id: string;
      label: string;
      link: string;
      active: boolean;
    }[];
    ctaButton?: {
      text: string;
      link: string;
      style: string;
    };
    mobileMenu?: boolean;
  };
}

@Component({
  selector: 'app-champs-home-page-preview',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ChampsPageHeaderComponent,
    ChampsPageFooterComponent,
    HeroLayout1PreviewComponent,
    HeroLayout2PreviewComponent,
    HeroLayout3PreviewComponent,
    HeroLayout4PreviewComponent,
    HeroLayout5PreviewComponent,
    HeroLayout6PreviewComponent,
    HeroLayout7PreviewComponent,
    InfoLayout1PreviewComponent,
    InfoLayout2PreviewComponent,
    InfoLayout3PreviewComponent,
    InfoLayout4PreviewComponent,
    InfoLayout5PreviewComponent,
    BookingLayout1PreviewComponent,
    BookingLayout2PreviewComponent,
    ContactLayout1PreviewComponent,
    ContactLayout2PreviewComponent,
  ],
  templateUrl: './home-page-preview.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./home-page-preview.component.scss'],
})
export class ChampsHomePagePreviewComponent implements OnChanges, OnInit, OnDestroy {
  @Input() elements: WebsiteElement[] = [];
  @Input() sectionVisibility: Record<string, boolean> = {};
  @Input() pages: any[] = [];
  @Input() deviceType: 'desktop' | 'tablet' | 'mobile' = 'desktop';
  @Input() primaryColor: string | null = null; // Primary color from theme
  @Input() headingColor: string | null = null; // Heading color from branding
  @Input() paragraphColor: string | null = null; // Paragraph/description color from branding
  @Input() headingFont: string | null = null; // Heading font from branding
  @Input() bodyFont: string | null = null; // Body font from branding
  @Input() pageData: any = null; // Page data to access json_data.website.header and json_data.website.footer
  @Output() elementSelect = new EventEmitter<WebsiteElement>();
  @Output() navigationClick = new EventEmitter<string>();

  // Testimonials carousel state
  currentTestimonialSlide = 0;
  private autoSlideInterval: any = null;
  private readonly AUTO_SLIDE_INTERVAL = 5000; // 5 seconds
  private touchStartX = 0;
  private touchEndX = 0;

  // Cache for map embed URL to prevent flickering
  private cachedMapEmbedUrl: string | null = null;
  private cachedMapEmbedUrlSource: string | null = null;

  // Loading and animation state
  isPageLoaded = false;
  private intersectionObserver?: IntersectionObserver;
  private animatedElements = new Set<Element>();

  constructor(
    private logger: LoggerService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {}

  // Element configuration for reusability
  readonly ELEMENT_CONFIG = {
    header: { class: 'header-element', index: 0 },
    hero: { class: 'hero-element', index: 1 },
    welcome: { class: 'section-element', index: 2 },
    testimonials: { class: 'testimonials-element', index: 3 },
    booking: { class: 'booking-element', index: 4 },
    contact: { class: 'contact-element', index: 5 },
    footer: { class: 'footer-element', index: 6 },
  };

  /**
   * Handle input property changes: initializes elements if empty and, when elements change, clears cached map URL and related caches, resets carousel state, and triggers necessary recomputations.
   * @example
   * gOnChanges({ elements: { currentValue: [...], previousValue: [...], firstChange: false } })
   * undefined
   * @param {{SimpleChanges}} {{changes}} - Object containing the changed input properties and their change details.
   * @returns {{void}} No return value.
   **/
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['elements'] && this.elements.length === 0) {
      this.initializeElements();
    }

    // Clear map embed URL cache when elements change to recalculate
    if (changes['elements']) {
      this.cachedMapEmbedUrl = null;
      this.cachedMapEmbedUrlSource = null;
      // Clear time field cache when elements change
      this.timeFieldCache.clear();
      // Clear date/time value cache when elements change
      this.dateTimeValueCache.clear();
      // Reset carousel when elements change
      this.currentTestimonialSlide = 0;
      this.resetAutoSlide();
    }

    // Note: Footer links are computed directly in template via getFooterQuickLinks()
    // which will automatically update when pages array changes due to Angular change detection
    // Header navigation comes from elements[0].content.navigation which is updated by
    // populateHeaderFromTemplate() in the parent component
  }

  private initializeElements(): void {
    this.elements = Object.keys(this.ELEMENT_CONFIG).map((key, index) => ({
      id: key,
      type: key as WebsiteElement['type'],
      content: {},
      selected: false,
    }));
  }

  onElementClick(element: WebsiteElement | undefined): void {
    if (!element) return;

    this.updateSelection(element);
    this.elementSelect.emit(element);
  }

  /**
   * Handle click on the footer: stop event propagation, ensure the footer element has type and id set to 'footer', then delegate to onElementClick.
   * @example
   * nFooterClick(sample_event)
   * void
   * @param {{Event}} {{event}} - The DOM event triggered by the footer click; propagation will be stopped.
   * @returns {{void}} No value is returned.
   **/
  onFooterClick(event: Event): void {
    event.stopPropagation();
    const footerElement = this.getFooterElement();
    if (footerElement) {
      // Ensure footer element has correct type and id
      if (!footerElement.type || footerElement.type !== 'footer') {
        footerElement.type = 'footer';
      }
      if (!footerElement.id || footerElement.id !== 'footer') {
        footerElement.id = 'footer';
      }
      this.onElementClick(footerElement);
    }
  }

  private updateSelection(selectedElement: WebsiteElement): void {
    this.elements.forEach(e => (e.selected = e.id === selectedElement.id));
  }

  getElementByIndex(index: number): WebsiteElement | undefined {
    return this.elements[index];
  }

  /**
   * Get footer element for selection (similar to express wash page)
   */
  getFooterElement(): WebsiteElement | undefined {
    return this.elements?.find(e => e.id === 'footer');
  }

  /**
   * Check if an element should be visible based on section visibility settings and existence
   */
  isElementVisible(elementId: string): boolean {
    // First check if element exists in elements array
    const elementExists = this.elements?.some(
      el => el.id === elementId || (el as any).originalKey === elementId
    );
    if (!elementExists) {
      return false; // Hide if element doesn't exist
    }

    // If no visibility map provided, show all existing elements
    if (!this.sectionVisibility || Object.keys(this.sectionVisibility).length === 0) {
      return true;
    }
    // Check visibility for this element ID
    return this.sectionVisibility[elementId] !== false;
  }

  getElementClass(type: string): string {
    return this.ELEMENT_CONFIG[type as keyof typeof this.ELEMENT_CONFIG]?.class || '';
  }

  getFormRows(formFields: any[]): any[][] {
    if (!formFields || formFields.length === 0) return [];

    const rows: any[][] = [];
    for (let i = 0; i < formFields.length; i += 2) {
      const row = formFields.slice(i, i + 2);
      rows.push(row);
    }
    return rows;
  }

  /**
   * Safely get form fields from element
   */
  getFormFields(element: WebsiteElement | undefined): any[] {
    return element?.content?.formFields || [];
  }

  /**
   * Get select options for a field
   */
  getSelectOptions(field: any): { value: string; label: string; disabled?: boolean }[] {
    if (!field) return [];
    return field.options || [];
  }

  /**
   * Check if a field is a date field
   */
  isDateField(field: any): boolean {
    return field?.type === 'date' || field?.type === 'datetime' || field?.type === 'datetime-local';
  }

  /**
   * Check if a field is a time field
   */
  isTimeField(field: any): boolean {
    return field?.type === 'time';
  }

  /**
   * Check if field should use custom date picker (date or datetime)
   */
  shouldUseDatePicker(field: any): boolean {
    try {
      if (!field) return false;
      return this.isDateField(field) || field?.type === 'datetime-local';
    } catch {
      return false;
    }
  }

  /**
   * Get the time field associated with a date field (if exists)
   * Cached to avoid repeated calculations
   */
  private timeFieldCache = new Map<string, any | null>();

  /**
   * Finds and returns a time field related to a given date field from a list of fields, using a cache for performance.
   * @example
   * etTimeFieldForDate([{ id: 'appointment_time', name: 'appointment_time' }, { id: 'appointment_date', name: 'appointment_date' }], { id: 'appointment_date', name: 'appointment_date' })
   * { id: 'appointment_time', name: 'appointment_time' }
   * @param {{any[]}} {{fields}} - Array of field objects to search for a matching time field.
   * @param {{any}} {{dateField}} - The date field object to find an associated time field for.
   * @returns {{any|null}} Return the matching time field object if found, otherwise null.
   **/
  getTimeFieldForDate(fields: any[], dateField: any): any | null {
    if (!dateField || !fields) return null;

    const cacheKey = `${dateField?.id || ''}_${dateField?.name || ''}`;
    if (this.timeFieldCache.has(cacheKey)) {
      return this.timeFieldCache.get(cacheKey);
    }

    const dateFieldName = (dateField?.name || dateField?.id || '').toLowerCase();
    // Look for a time field that might be related
    // Common patterns: "date" -> "time", "appointment_date" -> "appointment_time", etc.
    const timeField = fields.find(f => {
      if (!this.isTimeField(f)) return false;
      const timeFieldName = (f.name || f.id || '').toLowerCase();
      // Check if time field name is similar to date field name (e.g., "date" -> "time")
      const baseName = dateFieldName.replace('date', '').replace('_', '').trim();
      const timeBaseName = timeFieldName.replace('time', '').replace('_', '').trim();
      return (
        baseName === timeBaseName ||
        timeFieldName.includes(baseName) ||
        dateFieldName.includes(timeBaseName)
      );
    });

    const result = timeField || null;
    this.timeFieldCache.set(cacheKey, result);
    return result;
  }

  /**
   * Check if a time field should be hidden (because it's combined with a date field)
   */
  shouldHideTimeField(fields: any[], currentField: any): boolean {
    try {
      if (!currentField || !fields || !Array.isArray(fields)) return false;
      if (!this.isTimeField(currentField)) return false;
      // Check if any date field in the form is using this time field
      return fields.some(f => {
        if (this.isDateField(f)) {
          const associatedTimeField = this.getTimeFieldForDate(fields, f);
          return (
            associatedTimeField &&
            (associatedTimeField.id === currentField.id ||
              associatedTimeField.name === currentField.name)
          );
        }
        return false;
      });
    } catch {
      return false;
    }
  }

  /**
   * Check if a date field has already been processed (to avoid showing both date and time separately)
   */
  isDateFieldProcessed(fields: any[], currentIndex: number, field: any): boolean {
    // If this is a time field, check if there's a date field before it that we're combining
    if (this.isTimeField(field)) {
      for (let i = 0; i < currentIndex; i++) {
        const prevField = fields[i];
        if (this.isDateField(prevField)) {
          const timeField = this.getTimeFieldForDate(fields, prevField);
          if (timeField?.id === field.id || timeField?.name === field.name) {
            return true; // This time field is being combined with a date field
          }
        }
      }
    }
    return false;
  }

  /**
   * Get combined date/time value for date picker (safe version)
   * Uses caching to prevent change detection loops
   */
  getDateTimeValueSafe(element: WebsiteElement, dateField: any): Date | null {
    try {
      if (!element || !dateField) return null;

      const cacheKey = `${element.id || ''}_${dateField?.id || ''}_${dateField?.name || ''}`;
      const formData = this.getBookingFormData(element);
      const fields = this.getFormFields(element);
      const timeField = this.getTimeFieldForDate(fields, dateField);

      const dateKey = dateField?.name || dateField?.id;
      const dateValue = formData[dateKey];
      const timeValue = timeField ? formData[timeField?.name || timeField?.id] : null;

      if (!dateValue) {
        // Clear cache if no date value
        this.dateTimeValueCache.delete(cacheKey);
        return null;
      }

      // Create a cache key based on the actual values
      const valueKey = `${dateValue}_${timeValue || ''}`;
      const cachedKey = `${cacheKey}_${valueKey}`;

      // Check if we have a cached value for this exact date/time combination
      if (this.dateTimeValueCache.has(cachedKey)) {
        return this.dateTimeValueCache.get(cachedKey)!;
      }

      const date = new Date(dateValue);
      if (isNaN(date.getTime())) {
        this.dateTimeValueCache.delete(cacheKey);
        return null;
      }

      if (timeValue) {
        const [hours, minutes] = timeValue.split(':');
        if (hours && minutes) {
          date.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
        }
      }

      // Cache the value
      this.dateTimeValueCache.set(cachedKey, date);
      return date;
    } catch (error) {
      this.logger.warn('Error getting date/time value:', error);
      return null;
    }
  }

  /**
   * Handle date/time change from picker
   * Uses setTimeout to prevent change detection loops
   */
  onDateTimeChange(element: WebsiteElement, dateField: any, dateTime: Date | null): void {
    // Use setTimeout to break the change detection cycle
    setTimeout(() => {
      try {
        if (!element || !dateField) return;

        const formData = this.getBookingFormData(element);
        const fields = this.getFormFields(element);
        const timeField = this.getTimeFieldForDate(fields, dateField);

        const dateKey = dateField?.name || dateField?.id;
        const cacheKey = `${element.id || ''}_${dateField?.id || ''}_${dateField?.name || ''}`;

        if (!dateTime) {
          // Clear both date and time if dateTime is null
          formData[dateKey] = '';
          if (timeField) {
            const timeKey = timeField?.name || timeField?.id;
            formData[timeKey] = '';
          }
          // Clear cache
          this.dateTimeValueCache.delete(cacheKey);
          return;
        }

        // Set date value (YYYY-MM-DD format)
        const dateStr = dateTime.toISOString().split('T')[0];
        formData[dateKey] = dateStr;

        // Set time value (HH:MM format) if time field exists
        const timeValue = timeField
          ? `${dateTime.getHours().toString().padStart(2, '0')}:${dateTime.getMinutes().toString().padStart(2, '0')}`
          : null;
        if (timeField) {
          const timeKey = timeField?.name || timeField?.id;
          formData[timeKey] = timeValue!;
        }

        // Update cache with new value
        const valueKey = `${dateStr}_${timeValue || ''}`;
        const cachedKey = `${cacheKey}_${valueKey}`;
        this.dateTimeValueCache.set(cachedKey, dateTime);
      } catch (error) {
        this.logger.error('Error setting date/time value:', error);
      }
    }, 0);
  }

  /**
   * Get combined date/time value for date picker
   */
  getDateTimeValue(element: WebsiteElement, dateField: any, timeField?: any): Date | null {
    return this.getDateTimeValueSafe(element, dateField);
  }

  /**
   * Set combined date/time value
   */
  setDateTimeValue(
    element: WebsiteElement,
    dateField: any,
    timeField: any | null,
    dateTime: Date | null
  ): void {
    this.onDateTimeChange(element, dateField, dateTime);
  }

  // Header data helpers for shared component
  /**
   * Retrieve the header logo configuration from pageData JSON or fall back to the header element; returns a Logo object or null if none found.
   * @example
   * etHeaderLogo()
   * { image: 'https://example.com/logo.png', text: 'Logo', link: '/', alt: 'Logo' }
   * @returns {Logo|null} The header logo object with image, text, link, and alt properties, or null if no logo is available.
   */
  getHeaderLogo(): Logo | null {
    // Priority 1: Check json_data.website.header.logo (header section logo)
    if (this.pageData?.json_data?.website?.header?.logo) {
      const headerLogo = this.pageData.json_data.website.header.logo;
      if (headerLogo.url || headerLogo.image) {
        return {
          image: headerLogo.url || headerLogo.image || '',
          text: headerLogo.text || 'Logo',
          link: headerLogo.link || '/',
          alt: headerLogo.alt || 'Logo',
        };
      }
      if (headerLogo.text) {
        return {
          image: '',
          text: headerLogo.text,
          link: headerLogo.link || '/',
          alt: headerLogo.alt || 'Logo',
        };
      }
    }

    // Priority 2: Check header element content (fallback)
    const headerElement = this.getElementByIndex(0);
    if (headerElement?.content?.logo) {
      const logoContent = headerElement.content.logo as any;
      // If logo has image/url, return it
      if (logoContent.image || logoContent.url) {
        return {
          image: logoContent.image || logoContent.url || '',
          alt: logoContent.alt || 'Logo',
          text: logoContent.text,
          link: logoContent.link || '/',
        };
      }
      // If logo has text but no image, return text logo
      if (logoContent.text) {
        return {
          image: '',
          alt: logoContent.alt || 'Logo',
          text: logoContent.text,
          link: logoContent.link || '/',
        };
      }
    }
    return null;
  }

  /**
   * Builds header navigation items and returns them with normalized pageType values inferred from matching pages or the link.
   * @example
   * etHeaderNavigation()
   * [
   *   { label: 'Home', link: '/', pageType: 'home', active: true },
   *   { label: 'Express Washes', link: '/express-washes', pageType: 'express-wash-packages', active: false }
   * ]
   * @returns {NavigationItem[]} An array of navigation items containing label, link, pageType, and active.
   */
  getHeaderNavigation(): NavigationItem[] {
    const headerElement = this.getElementByIndex(0);
    if (headerElement?.content?.navigation) {
      return headerElement.content.navigation.map((nav: any) => {
        // Ensure pageType is set
        if (!nav.pageType) {
          const matchingPage = this.pages?.find(
            (p: any) =>
              p.name === nav.label ||
              (p as any).pageType === nav.link?.replace(/^#+|\/+$/g, '').replace(/^\/+/, '')
          );
          if (matchingPage) {
            nav.pageType = (matchingPage as any).pageType;
          } else {
            // Extract from link
            const normalizedLink = (nav.link || '')
              .replace(/^#+|\/+$/g, '')
              .replace(/^\/+/, '')
              .toLowerCase();
            if (
              normalizedLink === 'expresswashes' ||
              normalizedLink === 'express-washes' ||
              normalizedLink.includes('express-wash')
            ) {
              nav.pageType = 'express-wash-packages';
            } else if (
              normalizedLink === 'expressdetails' ||
              normalizedLink === 'express-details' ||
              normalizedLink.includes('express-detail') ||
              normalizedLink.includes('express-auto')
            ) {
              nav.pageType = 'express-auto-details';
            } else if (
              normalizedLink === 'fleets' ||
              normalizedLink === 'fleet' ||
              normalizedLink.includes('fleet')
            ) {
              nav.pageType = 'fleet-management';
            } else if (
              normalizedLink === 'coupons' ||
              normalizedLink === 'coupon' ||
              normalizedLink.includes('coupon')
            ) {
              nav.pageType = 'coupons';
            } else if (
              normalizedLink === '' ||
              normalizedLink === 'home' ||
              normalizedLink === '/'
            ) {
              nav.pageType = 'home';
            } else {
              nav.pageType = normalizedLink || 'home';
            }
          }
        }
        return {
          label: nav.label,
          link: nav.link,
          pageType: nav.pageType,
          active: nav.active,
        };
      });
    }
    return [];
  }

  /**
   * Get the CTA button object used in the header preview, falling back to defaults when missing.
   * @example
   * etHeaderCTAButton()
   * { text: 'Book Wash', link: '#booking', backgroundColor: '#1B5BFF', textColor: '#FFFFFF' }
   * @returns {CTAButton | null} CTA button configuration for the header preview or null if header element is unavailable.
   */
  getHeaderCTAButton(): CTAButton | null {
    const headerElement = this.getElementByIndex(0);
    const primaryColor = this.getPrimaryColor();
    if (headerElement?.content?.ctaButton) {
      const button = headerElement.content.ctaButton as any;
      return {
        text: button.text || '',
        link: button.link || '#booking', // Include link property
        // Use button's backgroundColor if provided, otherwise fall back to primaryColor
        backgroundColor: button.backgroundColor || primaryColor || '#1B5BFF',
        textColor: button.textColor || '#FFFFFF',
      };
    }
    // Fallback: return default button if no button data exists
    return {
      text: 'Book Wash',
      link: '#booking', // Include link property
      backgroundColor: primaryColor,
      textColor: '#FFFFFF',
    };
  }

  getHeaderBackgroundColor(): string | null {
    const headerElement = this.getElementByIndex(0);
    if (headerElement?.content?.backgroundColor) {
      return headerElement.content.backgroundColor as string;
    }
    return null;
  }

  /**
   * Get primary color from theme or use default
   */
  getPrimaryColor(): string {
    return this.primaryColor || '#1B5BFF';
  }

  /**
   * Get heading color from branding or use default
   */
  getHeadingColor(): string {
    return this.headingColor || '#15172E';
  }

  /**
   * Safely get title as string (handles API title.label object format)
   */
  getTitleSafe(element: WebsiteElement | undefined): string {
    if (!element?.content?.title) return '';
    const title = element.content.title;
    if (typeof title === 'string') return title;
    if (typeof title === 'object' && title !== null) {
      return (title as any).label || (title as any).text || (title as any).value || '';
    }
    return String(title);
  }

  /**
   * Get title styles from element content
   */
  getTitleStyles(element: WebsiteElement | undefined): any {
    if (!element?.content) {
      return {};
    }

    // Check if title is an object with style property (new API structure)
    if (typeof element.content.title === 'object' && element.content.title !== null) {
      const titleObj = element.content.title as any;
      if (titleObj.style) {
        const styleObj = titleObj.style;
        return {
          'font-weight': styleObj.fontWeight || 'normal',
          'font-style': styleObj.fontStyle || 'normal',
          'text-decoration': styleObj.textDecoration || 'none',
          'text-align': styleObj.textAlign || 'left',
        };
      }
    }

    // Fallback: check for titleStyle directly on content (old structure)
    if (element.content.titleStyle) {
      const style = element.content.titleStyle;
      // Handle both string and object types for compatibility
      if (typeof style === 'string') {
        return {}; // String type is for dark/modern themes, return empty for minimal theme
      }
      // Type guard: style is an object at this point
      const styleObj = style as {
        fontWeight?: 'bold' | null;
        fontStyle?: 'italic' | null;
        textDecoration?: 'underline' | null;
        textAlign?: 'left' | 'center' | 'right' | 'justify' | null;
      };
      return {
        'font-weight': styleObj.fontWeight || 'normal',
        'font-style': styleObj.fontStyle || 'normal',
        'text-decoration': styleObj.textDecoration || 'none',
        'text-align': styleObj.textAlign || 'left',
      };
    }

    return {};
  }

  /**
   * Get paragraph color from branding or use default
   */
  getParagraphColor(): string {
    return this.paragraphColor || '#6B7280';
  }

  /**
   * Get heading font from branding or use default
   */
  getHeadingFont(): string {
    return this.headingFont || 'Manrope';
  }

  /**
   * Get body font from branding or use default
   */
  getBodyFont(): string {
    return this.bodyFont || 'Inter';
  }

  isHeaderSelected(): boolean {
    return this.getElementByIndex(0)?.selected || false;
  }

  onHeaderClick(): void {
    const headerElement = this.getElementByIndex(0);
    if (headerElement) {
      this.onElementClick(headerElement);
    }
  }

  /**
   * Resolve and return the hero section layout key from the component's first element, defaulting to 'layout_1' if not found or invalid.
   * @example
   * etHeroLayout()
   * 'layout_3'
   * @returns {'layout_1' | 'layout_2' | 'layout_3' | 'layout_4' | 'layout_5' | 'layout_6' | 'layout_7'} One of the allowed layout keys (defaults to 'layout_1').
   **/
  getHeroLayout():
    'layout_1' | 'layout_2' | 'layout_3' | 'layout_4' | 'layout_5' | 'layout_6' | 'layout_7' {
    const heroElement = this.getElementByIndex(1);
    if (!heroElement) return 'layout_1';

    const layout = heroElement.content?.layout;
    if (!layout) return 'layout_1';

    // Handle API structure: layout is an object with type property
    if (typeof layout === 'object' && layout !== null && 'type' in layout) {
      const layoutType = (layout as any).type;
      if (typeof layoutType === 'string' && layoutType.startsWith('layout_')) {
        return layoutType as
          'layout_1' | 'layout_2' | 'layout_3' | 'layout_4' | 'layout_5' | 'layout_6' | 'layout_7';
      }
      // If type is just a number, convert to layout_X format
      if (typeof layoutType === 'string' && /^[1-7]$/.test(layoutType)) {
        return `layout_${layoutType}` as
          'layout_1' | 'layout_2' | 'layout_3' | 'layout_4' | 'layout_5' | 'layout_6' | 'layout_7';
      }
    }

    // Handle old format: layout is a string like '1', '2', etc.
    if (typeof layout === 'string') {
      if (layout.startsWith('layout_')) {
        return layout as
          'layout_1' | 'layout_2' | 'layout_3' | 'layout_4' | 'layout_5' | 'layout_6' | 'layout_7';
      }
      if (/^[1-7]$/.test(layout)) {
        return `layout_${layout}` as
          'layout_1' | 'layout_2' | 'layout_3' | 'layout_4' | 'layout_5' | 'layout_6' | 'layout_7';
      }
    }

    return 'layout_1';
  }

  getWelcomeLayout(): '1' | '2' | '3' {
    const welcomeElement = this.getElementByIndex(2);
    return (welcomeElement?.content?.layout as '1' | '2' | '3') || '1';
  }

  /**
   * Get all info section elements (info_section, info_section_1, etc.)
   */
  getInfoSectionElements(): WebsiteElement[] {
    return this.elements.filter(el => {
      return (
        el.type === 'section' || el.id === 'welcome' || (el.id && el.id.startsWith('welcome_'))
      );
    });
  }

  /**
   * Check if an element is an info section element
   * Includes info_section, info_section_1, etc.
   */
  isInfoSectionElement(element: WebsiteElement): boolean {
    if (!element) return false;
    // Match elements with type 'section', or IDs that start with 'welcome' or 'info'
    return (
      element.type === 'section' ||
      element.id === 'welcome' ||
      !!(element.id && element.id.startsWith('welcome_')) ||
      !!(element.id && element.id.startsWith('info_'))
    );
  }

  /**
   * Get layout for a specific info section element
   */
  getInfoSectionLayout(
    element: WebsiteElement
  ): 'layout_1' | 'layout_2' | 'layout_3' | 'layout_4' | 'layout_5' {
    if (!element) return 'layout_1';

    const layout = element.content?.layout;
    if (!layout) return 'layout_1';

    // Handle API structure: layout is an object with type property
    if (typeof layout === 'object' && layout !== null && 'type' in layout) {
      const layoutType = (layout as any).type;
      if (typeof layoutType === 'string' && layoutType.startsWith('layout_')) {
        if (
          layoutType === 'layout_1' ||
          layoutType === 'layout_2' ||
          layoutType === 'layout_3' ||
          layoutType === 'layout_4' ||
          layoutType === 'layout_5'
        ) {
          return layoutType as 'layout_1' | 'layout_2' | 'layout_3' | 'layout_4' | 'layout_5';
        }
      }
      // If type is just a number, convert to layout_X format
      if (typeof layoutType === 'string' && /^[1-5]$/.test(layoutType)) {
        return `layout_${layoutType}` as
          'layout_1' | 'layout_2' | 'layout_3' | 'layout_4' | 'layout_5';
      }
    }

    // Handle old format: layout is a string like '1', '2', etc.
    if (typeof layout === 'string') {
      if (layout.startsWith('layout_')) {
        if (
          layout === 'layout_1' ||
          layout === 'layout_2' ||
          layout === 'layout_3' ||
          layout === 'layout_4' ||
          layout === 'layout_5'
        ) {
          return layout as 'layout_1' | 'layout_2' | 'layout_3' | 'layout_4' | 'layout_5';
        }
      }
      if (/^[1-5]$/.test(layout)) {
        return `layout_${layout}` as 'layout_1' | 'layout_2' | 'layout_3' | 'layout_4' | 'layout_5';
      }
    }

    return 'layout_1';
  }

  /**
   * Get hero background color from layout object or content
   */
  getHeroBackgroundColor(): string | undefined {
    const heroElement = this.getElementByIndex(1);
    if (!heroElement) return undefined;

    // Check if layout is an object with background_color
    const layout = heroElement.content?.layout;
    if (typeof layout === 'object' && layout !== null && 'background_color' in layout) {
      return (layout as any).background_color;
    }

    // Fallback to content.backgroundColor
    return heroElement.content?.backgroundColor;
  }

  /**
   * Get hero data for layout component
   */
  getHeroLayoutData() {
    const heroElement = this.getElementByIndex(1);
    if (!heroElement) return null;

    // Get background color from layout object if available
    const backgroundColor = this.getHeroBackgroundColor();

    return {
      title: heroElement.content?.title,
      subtitle: heroElement.content?.subtitle,
      description: heroElement.content?.description,
      buttonText: heroElement.content?.buttonText,
      buttonLink: heroElement.content?.buttonLink,
      image: heroElement.content?.image,
      imageUrl: heroElement.content?.imageUrl,
      backgroundColor: backgroundColor,
      titleStyle: heroElement.content?.titleStyle,
    };
  }

  /**
   * Get info layout data for layout components
   */
  getInfoLayoutData(
    element: WebsiteElement
  ): InfoLayout1Data | InfoLayout2Data | InfoLayout3Data | InfoLayout4Data | InfoLayout5Data {
    // Extract title from title.label if it's an object, otherwise use title directly
    const title =
      typeof element.content?.title === 'object' && element.content?.title !== null
        ? (element.content.title as any).label || element.content.title
        : element.content?.title;

    // Extract titleStyle from title.style if it exists
    let titleStyle: any = undefined;
    if (typeof element.content?.title === 'object' && element.content?.title !== null) {
      const titleObj = element.content.title as any;
      if (titleObj.style) {
        titleStyle = {
          fontWeight: titleObj.style.fontWeight || null,
          fontStyle: titleObj.style.fontStyle || null,
          textDecoration: titleObj.style.textDecoration || null,
          textAlign: titleObj.style.textAlign || null,
        };
      }
    } else if (element.content?.titleStyle) {
      titleStyle = element.content.titleStyle;
    }

    return {
      title: title,
      description: element.content?.description,
      subtitle: element.content?.subtitle,
      buttonText: element.content?.buttonText,
      buttonLink: element.content?.buttonLink,
      image: element.content?.image,
      imageUrl: element.content?.imageUrl,
      backgroundColor: element.content?.backgroundColor,
      titleStyle: titleStyle,
    };
  }

  /**
   * Get booking layout type
   */
  getBookingLayout(element: WebsiteElement): 'layout_1' | 'layout_2' {
    if (!element) return 'layout_1';

    const layout = element.content?.layout;
    if (!layout) return 'layout_1';

    // Handle API structure: layout is an object with type property
    if (typeof layout === 'object' && layout !== null && 'type' in layout) {
      const layoutType = (layout as any).type;
      if (typeof layoutType === 'string' && layoutType.startsWith('layout_')) {
        return layoutType === 'layout_2' ? 'layout_2' : 'layout_1';
      }
      if (typeof layoutType === 'string' && layoutType === '2') {
        return 'layout_2';
      }
    }

    // Handle old format: layout is a string like '1', '2', etc.
    if (typeof layout === 'string') {
      if (layout === 'layout_2' || layout === '2') {
        return 'layout_2';
      }
    }

    return 'layout_1';
  }

  /**
   * Get booking layout data for layout component
   */
  getBookingLayoutData(element: WebsiteElement): BookingLayout1Data | BookingLayout2Data {
    // Extract title from title.label if it's an object, otherwise use title directly
    const title =
      typeof element.content?.title === 'object' && element.content?.title !== null
        ? (element.content.title as any).label || element.content.title
        : element.content?.title;

    // Extract button text and colors from button object
    // Check both structures: content.button.backgroundColor (editor format) and content.buttonBackgroundColor (website preview format)
    const content = element.content as any;
    const buttonText =
      content?.button?.text || content?.buttonText || content?.button?.label || 'Book Appointment';
    const buttonBackgroundColor =
      content?.button?.backgroundColor ||
      content?.button?.style?.background ||
      content?.buttonBackgroundColor ||
      null;
    const buttonTextColor =
      content?.button?.textColor ||
      content?.button?.style?.color ||
      content?.buttonTextColor ||
      null;

    return {
      title: title || '',
      description: element.content?.description || element.content?.subtitle || '',
      buttonText: buttonText,
      buttonBackgroundColor: buttonBackgroundColor,
      buttonTextColor: buttonTextColor,
      backgroundColor: element.content?.backgroundColor,
    };
  }

  /**
   * Get contact layout for a specific contact element
   */
  getContactLayout(element: WebsiteElement): 'layout_1' | 'layout_2' {
    if (!element) return 'layout_1';

    const layout = element.content?.layout;
    if (!layout) return 'layout_1';

    // Handle API structure: layout is an object with type property
    if (typeof layout === 'object' && layout !== null && 'type' in layout) {
      const layoutType = (layout as any).type;
      if (typeof layoutType === 'string' && layoutType.startsWith('layout_')) {
        if (layoutType === 'layout_1' || layoutType === 'layout_2') {
          return layoutType as 'layout_1' | 'layout_2';
        }
      }
      // If type is just a number, convert to layout_X format
      if (typeof layoutType === 'string' && /^[12]$/.test(layoutType)) {
        return `layout_${layoutType}` as 'layout_1' | 'layout_2';
      }
    }

    // Handle old format: layout is a string like '1', '2', etc.
    if (typeof layout === 'string') {
      if (layout.startsWith('layout_')) {
        if (layout === 'layout_1' || layout === 'layout_2') {
          return layout as 'layout_1' | 'layout_2';
        }
      }
      if (/^[12]$/.test(layout)) {
        return `layout_${layout}` as 'layout_1' | 'layout_2';
      }
    }

    return 'layout_1';
  }

  /**
   * Get contact layout data for layout component
   */
  getContactLayoutData(element: WebsiteElement): ContactLayout1Data | ContactLayout2Data {
    const address =
      element.content?.address ||
      (element.content?.contactInfo?.address
        ? typeof element.content.contactInfo.address === 'string'
          ? element.content.contactInfo.address
          : this.getFullAddressFromContactData(element)
        : '');

    // Get map embed URL - it's a direct property on content, not nested in map
    const mapEmbedUrl = element.content?.mapEmbedUrl || '';

    // Get map image - it's in map.image property
    const mapImage = element.content?.map?.image || '';

    // Extract phone - handle both string and object formats
    const phoneValue = element.content?.phone || element.content?.contactInfo?.phone;
    const phone =
      typeof phoneValue === 'string'
        ? phoneValue
        : phoneValue && typeof phoneValue === 'object'
          ? (phoneValue as any).value ||
            (phoneValue as any).phone ||
            (phoneValue as any).label ||
            ''
          : '';

    // Extract email - handle both string and object formats
    const emailValue = element.content?.email || element.content?.contactInfo?.email;
    const email =
      typeof emailValue === 'string'
        ? emailValue
        : emailValue && typeof emailValue === 'object'
          ? (emailValue as any).value ||
            (emailValue as any).email ||
            (emailValue as any).label ||
            ''
          : '';

    // Return data that satisfies both ContactLayout1Data and ContactLayout2Data
    // Both interfaces now have the same structure, so this works for both
    return {
      title: this.getTitleSafe(element) || 'Contact Us',
      subtitle: element.content?.description || element.content?.subtitle || '',
      address: address,
      phone: phone,
      email: email,
      mapEmbedUrl: mapEmbedUrl,
      mapImage: mapImage,
      businessHours: element.content?.businessHours || [],
      backgroundColor: element.content?.backgroundColor,
    } as ContactLayout1Data & ContactLayout2Data;
  }

  /**
   * Get full address from contact data (helper method)
   */
  private getFullAddressFromContactData(element: WebsiteElement): string {
    const addr = element.content?.contactInfo?.address;
    if (!addr || typeof addr === 'string') return addr || '';
    const parts = [
      (addr as any).street,
      (addr as any).city,
      (addr as any).state,
      (addr as any).zipCode,
    ].filter(p => p);
    return parts.join(', ');
  }

  /**
   * Handle booking form submit from layout component
   */
  onBookingLayoutSubmit(
    element: WebsiteElement,
    formData: Record<string, any>,
    event: Event
  ): void {
    this.onBookingSubmit(element, event);
  }

  /**
   * Handle field change from layout component
   */
  onBookingLayoutFieldChange(element: WebsiteElement, field: any, value: any): void {
    this.setFieldValue(element, field, value);
  }

  /**
   * Handle date/time change from layout component
   */
  onBookingLayoutDateTimeChange(element: WebsiteElement, field: any, dateTime: Date | null): void {
    this.onDateTimeChange(element, field, dateTime);
  }

  /**
   * Check if an info section element should be visible
   */
  isInfoSectionVisible(element: WebsiteElement): boolean {
    // First check if element exists and has content
    if (!element || !element.content) {
      return false; // Hide if element doesn't exist or has no content
    }

    if (!this.sectionVisibility || Object.keys(this.sectionVisibility).length === 0) {
      return true;
    }

    // Check visibility by element ID
    if (this.sectionVisibility[element.id] !== undefined) {
      return this.sectionVisibility[element.id] !== false;
    }

    // Check visibility by original key if available
    const originalKey = (element as any).originalKey;
    if (originalKey && this.sectionVisibility[originalKey] !== undefined) {
      return this.sectionVisibility[originalKey] !== false;
    }

    // Default to visible if element exists
    return true;
  }

  /**
   * Convert a button link to a page type for navigation
   */
  convertLinkToPageType(link: string | undefined): string {
    if (!link) return 'home';

    // Remove leading/trailing slashes and normalize
    const normalizedLink = link.replace(/^\/+|\/+$/g, '').toLowerCase();

    if (!normalizedLink || normalizedLink === 'home' || normalizedLink === '') return 'home';
    if (normalizedLink.includes('express-wash') || normalizedLink === 'express-washes')
      return 'express-wash-packages';
    if (
      normalizedLink.includes('express-detail') ||
      normalizedLink.includes('express-auto') ||
      normalizedLink === 'express-details'
    )
      return 'express-auto-details';
    if (normalizedLink.includes('fleet')) return 'fleet-management';
    if (normalizedLink.includes('coupon')) return 'coupons';

    // Try to match with page names
    const matchingPage = this.pages.find(p => {
      const pageName = (p.name || '').toLowerCase();
      const pagePath = (p.path || '').replace(/^\/+|\/+$/g, '').toLowerCase();
      return pageName === normalizedLink || pagePath === normalizedLink;
    });

    if (matchingPage) {
      const normalizedName = matchingPage.name.toLowerCase().trim();
      if (normalizedName === 'home') return 'home';
      if (normalizedName.includes('express wash') || normalizedName.includes('express_wash'))
        return 'express-wash-packages';
      if (
        normalizedName.includes('express detail') ||
        normalizedName.includes('express_detail') ||
        normalizedName.includes('express auto')
      )
        return 'express-auto-details';
      if (normalizedName.includes('fleet')) return 'fleet-management';
      if (normalizedName.includes('coupon')) return 'coupons';
    }

    return 'home';
  }

  /**
   * Handle button click - navigate to the page specified by buttonLink
   */
  onButtonClick(buttonLink: string | undefined, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const pageType = this.convertLinkToPageType(buttonLink);
    this.navigationClick.emit(pageType);
  }

  /**
   * Check whether a given WebsiteElement (or the default contact element) contains a non-empty businessHours array.
   * @example
   * asBusinessHours(contactElement)
   * true
   * @param {WebsiteElement} element - Optional WebsiteElement to inspect; if omitted the method uses the default contact element.
   * @returns {boolean} True if the element contains a non-empty businessHours array, otherwise false.
   **/
  hasBusinessHours(element?: WebsiteElement): boolean {
    const contactElement = element || this.getElementByIndex(5);
    const hasHours = !!(
      contactElement?.content?.businessHours &&
      Array.isArray(contactElement.content.businessHours) &&
      contactElement.content.businessHours.length > 0
    );
    this.logger.debug('hasBusinessHours check:', {
      hasContactElement: !!contactElement,
      hasBusinessHours: !!contactElement?.content?.businessHours,
      isArray: Array.isArray(contactElement?.content?.businessHours),
      length: contactElement?.content?.businessHours?.length || 0,
      result: hasHours,
      businessHours: contactElement?.content?.businessHours,
    });
    return hasHours;
  }

  /**
   * Retrieve and cache a sanitized SafeResourceUrl for an embedded map from a WebsiteElement or the component's default element.
   * @example
   * etMapEmbedUrl()
   * SafeResourceUrl | null
   * @param {WebsiteElement} [element] - Optional element containing contact.content.mapEmbedUrl to extract.
   * @returns {SafeResourceUrl|null} Returns a sanitized SafeResourceUrl for a valid http(s) embed URL or null if extraction/validation fails.
   **/
  getMapEmbedUrl(element?: WebsiteElement): SafeResourceUrl | null {
    const contactElement = element || this.getElementByIndex(5);
    const mapEmbedUrl = contactElement?.content?.mapEmbedUrl;

    if (!mapEmbedUrl || typeof mapEmbedUrl !== 'string') {
      // Clear cache if no URL
      this.cachedMapEmbedUrl = null;
      this.cachedMapEmbedUrlSource = null;
      return null;
    }

    // Extract URL from iframe HTML if needed
    const trimmedUrl = mapEmbedUrl.trim();

    // Check if we have a cached value for this URL
    if (this.cachedMapEmbedUrl && this.cachedMapEmbedUrlSource === trimmedUrl) {
      return this.cachedMapEmbedUrl;
    }

    // Process the URL
    let processedUrl: string | null = null;

    // If it's already a clean URL (starts with http:// or https://), use it directly
    if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
      processedUrl = trimmedUrl;
    }
    // If it contains iframe HTML, extract the src URL
    else if (trimmedUrl.includes('<iframe') || trimmedUrl.includes('&lt;iframe')) {
      try {
        // Try regex extraction first
        const srcMatch = trimmedUrl.match(/src\s*=\s*"([^"]+)"|src\s*=\s*'([^']+)'/i);
        if (srcMatch) {
          const extractedUrl = (srcMatch[1] || srcMatch[2] || '').trim();
          if (extractedUrl) {
            // Decode HTML entities
            processedUrl = extractedUrl
              .replace(/&quot;/g, '"')
              .replace(/&#39;/g, "'")
              .replace(/&amp;/g, '&');
          }
        }

        // Try DOMParser as fallback if regex didn't work
        if (!processedUrl) {
          const wrappedHtml = `<div>${trimmedUrl}</div>`;
          const parser = new DOMParser();
          const doc = parser.parseFromString(wrappedHtml, 'text/html');
          const iframe = doc.querySelector('iframe');
          if (iframe) {
            processedUrl = iframe.getAttribute('src');
          }
        }
      } catch (error) {
        this.logger.warn('Error extracting URL from iframe HTML:', error);
        this.cachedMapEmbedUrl = null;
        this.cachedMapEmbedUrlSource = null;
        return null;
      }
    }

    // If we couldn't extract a valid URL, clear cache and return null
    if (!processedUrl) {
      this.cachedMapEmbedUrl = null;
      this.cachedMapEmbedUrlSource = null;
      return null;
    }

    // Only allow http(s) URLs — reject javascript:, data:, or any other scheme
    if (!processedUrl.startsWith('https://') && !processedUrl.startsWith('http://')) {
      this.cachedMapEmbedUrl = null;
      this.cachedMapEmbedUrlSource = null;
      return null;
    }

    // Sanitize URL instead of bypassing (safe for iframe src)
    const sanitized = this.sanitizer.sanitize(SecurityContext.URL, processedUrl);
    if (!sanitized) {
      this.cachedMapEmbedUrl = null;
      this.cachedMapEmbedUrlSource = null;
      return null;
    }
    this.cachedMapEmbedUrl = sanitized;
    this.cachedMapEmbedUrlSource = trimmedUrl;
    return this.cachedMapEmbedUrl;
  }

  /**
   * Get footer quick links from footer element or active pages
   * Filters out pages where visible === false (active === false)
   */
  getFooterQuickLinks(): { label: string; link: string }[] {
    // First, try to get from footer element content
    const footerElement = this.getFooterElement();
    const footerContent = footerElement?.content as any;
    const storedLinks = Array.isArray(footerContent?.quickLinks) ? footerContent.quickLinks : [];
    return resolveFooterQuickLinks(storedLinks, this.pages);
  }

  /**
   * Get footer social links from footer element
   */
  getFooterSocialLinks(): { platform: string; url: string; icon: string }[] {
    const footerElement = this.getFooterElement();
    const footerContent = footerElement?.content as any;

    // Handle different data structures:
    // 1. socialLinks as array (from website builder)
    if (footerContent?.socialLinks && Array.isArray(footerContent.socialLinks)) {
      return footerContent.socialLinks.map((social: any) => ({
        platform: social.platform || '',
        url: social.url || social.link || '#',
        icon: social.icon || social.platform?.toLowerCase() || 'link',
      }));
    }

    // 2. socialLinks as object with platforms array (from website preview)
    if (
      footerContent?.socialLinks?.platforms &&
      Array.isArray(footerContent.socialLinks.platforms)
    ) {
      return footerContent.socialLinks.platforms.map((social: any) => ({
        platform: social.platform || '',
        url: social.url || social.link || '#',
        icon: social.icon || social.platform?.toLowerCase() || 'link',
      }));
    }

    // 3. Check for social_links.platforms (alternative structure)
    if (
      footerContent?.social_links?.platforms &&
      Array.isArray(footerContent.social_links.platforms)
    ) {
      return footerContent.social_links.platforms.map((social: any) => ({
        platform: social.platform || '',
        url: social.url || social.link || '#',
        icon: social.icon || social.platform?.toLowerCase() || 'link',
      }));
    }

    // 4. Check for social_links as array
    if (footerContent?.social_links && Array.isArray(footerContent.social_links)) {
      return footerContent.social_links.map((social: any) => ({
        platform: social.platform || '',
        url: social.url || social.link || '#',
        icon: social.icon || social.platform?.toLowerCase() || 'link',
      }));
    }

    return [];
  }

  getFooterSocialLinksTitle(): string {
    const footerElement = this.getFooterElement();
    const footerContent = footerElement?.content as any;
    const title = footerContent?.socialLinksTitle;
    if (typeof title === 'string') {
      return title;
    } else if (title && typeof title === 'object' && title.text) {
      return title.text;
    }
    return 'Connect with us';
  }

  getFooterQuickLinksTitle(): string {
    const footerElement = this.getFooterElement();
    const footerContent = footerElement?.content as any;
    const title = footerContent?.quickLinksTitle;
    if (typeof title === 'string') {
      return title;
    } else if (title && typeof title === 'object' && title.text) {
      return title.text;
    }
    return 'Quick links';
  }

  /**
   * Get footer copyright text from footer element
   */
  getFooterCopyright(): string {
    const footerElement = this.getFooterElement();
    const footerContent = footerElement?.content as any;
    const copyright = footerContent?.copyright;
    if (typeof copyright === 'string') {
      return copyright;
    } else if (copyright && typeof copyright === 'object' && copyright.text) {
      return copyright.text;
    }
    return `Copyright © ${new Date().getFullYear()} way.com. All rights reserved.`;
  }

  /**
   * Get footer logo from footer element content (populated from json_data.website.footer.logo)
   */
  getFooterLogo(): { text?: string; image?: string } | undefined {
    // Get logo from footer element content (populated by populateFooterFromTemplate from json_data.website.footer.logo)
    const footerElement = this.getFooterElement();
    const footerContent = footerElement?.content as any;

    if (footerContent?.logo) {
      const logo = footerContent.logo;
      return {
        text: logo.text || 'way',
        image: logo.image || logo.url || '',
      };
    }

    // Fallback to header logo if footer logo not available
    const headerLogo = this.getHeaderLogo();
    if (headerLogo && headerLogo.image) {
      return {
        text: headerLogo.text,
        image: headerLogo.image,
      };
    }
    return { text: 'way' };
  }

  /**
   * Get footer background color from footer element
   */
  getFooterBackgroundColor(): string {
    const footerElement = this.getFooterElement();
    const footerContent = footerElement?.content as any;
    if (footerContent?.backgroundColor) {
      return footerContent.backgroundColor;
    }
    return '#1E4A52';
  }

  /**
   * Check if a section is visible (similar to express wash page)
   */
  isSectionVisible(sectionKey: string): boolean {
    if (!this.sectionVisibility || Object.keys(this.sectionVisibility).length === 0) {
      return true;
    }
    return this.sectionVisibility[sectionKey] !== false;
  }

  onNavigationClick(pageType: string): void {
    this.navigationClick.emit(pageType);
  }

  /**
   * Get testimonials array from testimonials element
   */
  getTestimonials(): any[] {
    const testimonialsElement = this.getElementByIndex(3);
    return testimonialsElement?.content?.testimonials || [];
  }

  /**
   * Get total number of testimonial slides (showing 3 per slide on desktop, 1 on mobile/tablet)
   */
  getTotalTestimonialSlides(): number {
    const testimonials = this.getTestimonials();
    if (testimonials.length === 0) return 0;

    if (this.deviceType === 'desktop') {
      // Desktop: show 3 testimonials per slide
      return Math.ceil(testimonials.length / 3);
    } else {
      // Mobile/Tablet: show 1 testimonial per slide
      return testimonials.length;
    }
  }

  /**
   * Get testimonials for current slide
   */
  getTestimonialsForSlide(slideIndex: number): any[] {
    const testimonials = this.getTestimonials();
    if (testimonials.length === 0) return [];

    if (this.deviceType === 'desktop') {
      // Desktop: 3 testimonials per slide
      const startIndex = slideIndex * 3;
      return testimonials.slice(startIndex, startIndex + 3);
    } else {
      // Mobile/Tablet: 1 testimonial per slide
      return [testimonials[slideIndex]].filter(Boolean);
    }
  }

  /**
   * Get pagination dots array
   */
  getTestimonialPaginationDots(): number[] {
    const total = this.getTotalTestimonialSlides();
    return Array.from({ length: total }, (_, i) => i);
  }

  /**
   * Navigate to specific slide
   */
  goToTestimonialSlide(index: number): void {
    const total = this.getTotalTestimonialSlides();
    if (index >= 0 && index < total) {
      this.currentTestimonialSlide = index;
      this.resetAutoSlide();
    }
  }

  /**
   * Navigate to next slide
   */
  nextTestimonialSlide(): void {
    const total = this.getTotalTestimonialSlides();
    if (this.currentTestimonialSlide < total - 1) {
      this.currentTestimonialSlide++;
    } else {
      // Loop back to first slide
      this.currentTestimonialSlide = 0;
    }
    this.resetAutoSlide();
  }

  /**
   * Navigate to previous slide
   */
  prevTestimonialSlide(): void {
    const total = this.getTotalTestimonialSlides();
    if (this.currentTestimonialSlide > 0) {
      this.currentTestimonialSlide--;
    } else {
      // Loop to last slide
      this.currentTestimonialSlide = total - 1;
    }
    this.resetAutoSlide();
  }

  /**
   * Start auto-slide
   */
  startAutoSlide(): void {
    this.stopAutoSlide();
    this.autoSlideInterval = setInterval(() => {
      this.nextTestimonialSlide();
    }, this.AUTO_SLIDE_INTERVAL);
  }

  /**
   * Stop auto-slide
   */
  stopAutoSlide(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }

  /**
   * Reset auto-slide (restart timer)
   */
  resetAutoSlide(): void {
    this.startAutoSlide();
  }

  /**
   * Handle touch start for swipe
   */
  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  /**
   * Handle touch end for swipe
   */
  onTouchEnd(event: TouchEvent): void {
    this.touchEndX = event.changedTouches[0].screenX;
    this.handleSwipe();
  }

  /**
   * Handle swipe gesture
   */
  private handleSwipe(): void {
    const swipeThreshold = 50; // Minimum distance for swipe
    const diff = this.touchStartX - this.touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe left - next slide
        this.nextTestimonialSlide();
      } else {
        // Swipe right - previous slide
        this.prevTestimonialSlide();
      }
    }
  }

  /**
   * Initialize carousel on component init
   */
  ngOnInit(): void {
    // Start auto-slide when component initializes if there are testimonials
    const testimonials = this.getTestimonials();
    if (testimonials.length > 0 && this.getTotalTestimonialSlides() > 1) {
      this.startAutoSlide();
    }

    // Initialize page loading state
    this.isPageLoaded = false;

    // Simulate page load animation
    setTimeout(() => {
      this.isPageLoaded = true;
      this.cdr.detectChanges();
      // Initialize scroll animations after page loads
      setTimeout(() => this.initScrollAnimations(), 100);
    }, 300);
  }

  /**
   * Cleanup on component destroy
   */
  ngOnDestroy(): void {
    this.stopAutoSlide();

    // Clean up intersection observer
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
    this.animatedElements.clear();
  }

  /**
   * Initialize scroll animations using Intersection Observer
   */
  private initScrollAnimations(): void {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      return; // Fallback for browsers without IntersectionObserver
    }

    // Use requestAnimationFrame for smoother performance
    requestAnimationFrame(() => {
      // Create intersection observer for scroll animations with optimized settings
      this.intersectionObserver = new IntersectionObserver(
        entries => {
          // Use requestAnimationFrame to batch DOM updates
          requestAnimationFrame(() => {
            entries.forEach(entry => {
              if (entry.isIntersecting && !this.animatedElements.has(entry.target)) {
                entry.target.classList.add('animate-in');
                this.animatedElements.add(entry.target);
                // Unobserve after animation to improve performance
                this.intersectionObserver?.unobserve(entry.target);
              }
            });
          });
        },
        {
          threshold: [0.1, 0.2], // Multiple thresholds for smoother detection
          rootMargin: '0px 0px -80px 0px', // Reduced margin for better scroll performance
        }
      );

      // Observe all animatable elements with delay to avoid blocking initial render
      setTimeout(() => {
        const elements = document.querySelectorAll(
          '.home-page-preview .website-element:not(.hero-element)'
        );
        elements.forEach(el => {
          // Check if element is already in viewport
          const rect = el.getBoundingClientRect();
          const isInViewport = rect.top < window.innerHeight + 100 && rect.bottom > -100;

          el.classList.add('scroll-animate');

          // If element is already visible, animate it immediately
          if (isInViewport) {
            requestAnimationFrame(() => {
              el.classList.add('animate-in');
              this.animatedElements.add(el);
            });
          } else {
            // Only observe if not already in viewport
            this.intersectionObserver?.observe(el);
          }
        });
      }, 300);
    });
  }

  /**
   * Track by function for slides
   */
  trackByIndex(index: number): number {
    return index;
  }

  /**
   * Track by function for testimonials
   */
  trackByTestimonialId(index: number, testimonial: any): string {
    return testimonial?.id || index.toString();
  }

  /**
   * Form data storage for booking forms
   * Maps element ID to form field values
   */
  private bookingFormData = new Map<string, Record<string, any>>();

  /**
   * Cache for date/time values to prevent change detection loops
   * Maps element ID + field ID to Date object
   */
  private dateTimeValueCache = new Map<string, Date | null>();

  /**
   * Get form data object for a specific booking element
   */
  getBookingFormData(element: WebsiteElement): Record<string, any> {
    const elementId = element.id || 'booking';
    if (!this.bookingFormData.has(elementId)) {
      this.bookingFormData.set(elementId, {});
    }
    return this.bookingFormData.get(elementId)!;
  }

  /**
   * Get field value for a specific field in a booking form
   * Optimized to avoid change detection loops
   */
  getFieldValue(element: WebsiteElement, field: any): any {
    if (!element || !field) return '';
    try {
      const elementId = element.id || 'booking';
      const formData = this.bookingFormData.get(elementId);
      if (!formData) return '';
      const fieldKey = field.name || field.id;
      return formData[fieldKey] || '';
    } catch {
      return '';
    }
  }

  /**
   * Safe version of getFieldValue that never throws
   */
  getFieldValueSafe(element: WebsiteElement, field: any): string {
    try {
      return this.getFieldValue(element, field) || '';
    } catch {
      return '';
    }
  }

  /**
   * Handle input event for form fields
   */
  onFieldInput(element: WebsiteElement, field: any, event: Event): void {
    event.stopPropagation();
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    if (target && field) {
      this.setFieldValue(element, field, target.value);
    }
  }

  /**
   * Handle change event for select fields
   */
  onFieldChange(element: WebsiteElement, field: any, event: Event): void {
    event.stopPropagation();
    const target = event.target as HTMLSelectElement;
    if (target && field) {
      this.setFieldValue(element, field, target.value);
    }
  }

  /**
   * Set field value for a specific field in a booking form
   * Optimized to avoid change detection loops
   */
  setFieldValue(element: WebsiteElement, field: any, value: any): void {
    if (!element || !field) return;
    try {
      const elementId = element.id || 'booking';
      let formData = this.bookingFormData.get(elementId);
      if (!formData) {
        formData = {};
        this.bookingFormData.set(elementId, formData);
      }
      const fieldKey = field.name || field.id;
      formData[fieldKey] = value;
    } catch {
      // Silently fail to avoid breaking the UI
    }
  }

  /**
   * TrackBy function for form rows
   */
  trackByRowIndex(index: number): number {
    return index;
  }

  /**
   * TrackBy function for form fields
   */
  trackByFieldId(index: number, field: any): string {
    return field?.id || field?.name || index.toString();
  }

  /**
   * Handle form click - allow date picker clicks to work, but stop propagation for other clicks
   */
  onFormClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target) return;

    // Check if click is on date picker or its children
    const isDatePickerClick =
      target.closest('.custom-date-picker') !== null ||
      target.closest('.date-picker-wrapper') !== null ||
      target.closest('.date-picker-input') !== null ||
      target.closest('.date-picker-dropdown') !== null ||
      target.classList.contains('custom-date-picker') ||
      target.classList.contains('date-picker-input') ||
      target.classList.contains('date-picker-dropdown');

    // Only stop propagation if it's NOT a date picker click
    // This allows the date picker's internal click handlers to work
    if (!isDatePickerClick) {
      event.stopPropagation();
    }
  }

  /**
   * Handle booking form submission
   */
  onBookingSubmit(element: WebsiteElement, event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    const elementId = element.id || 'booking';
    const formData = this.bookingFormData.get(elementId) || {};

    this.logger.debug('Booking form submitted:', {
      elementId,
      formData,
      element,
    });

    // Emit form submission event or handle as needed
    // For now, just log it
  }
}
